import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminFormDefinitionVersionsStateData } from "@/types/form-fields"

export type AdminFormDefinitionVersionsState = {
  data: AdminFormDefinitionVersionsStateData
  error: string | null
}

export const adminFormDefinitionVersionsInitialState: AdminFormDefinitionVersionsState = {
  data: {
    versions: [],
  },
  error: null,
}

const slice = createSlice({
  name: "adminFormDefinitionVersions",
  initialState: adminFormDefinitionVersionsInitialState,
  reducers: {
    setAdminFormDefinitionVersionsAction(
      state,
      { payload }: PayloadAction<AdminFormDefinitionVersionsStateData>,
    ) {
      state.data = payload
      state.error = null
    },
    setAdminFormDefinitionVersionsErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const {
  setAdminFormDefinitionVersionsAction,
  setAdminFormDefinitionVersionsErrorAction,
} = slice.actions
export default slice.reducer
